<template>
  <div class="xv_view" id="Citizens_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Citizens</label>
      </div>
      <div class="xv_actions">
        <button class="main_btn" @click="add_citizen()">
          Add Citizen
          <span class="mdi mdi-plus-thick"></span>
        </button>
      </div>
    </div>

    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Citizens (12)</span>
        </div>
        <div>
          <button class="sec_btn" @click="table_filter()">
            Filter
            <span class="mdi mdi-filter-menu"></span>
          </button>
          <label class="table_search">
            <span class="mdi mdi-magnify"></span>
            <input type="text" placeholder="Search by Name" />
          </label>
        </div>
      </div>
      <div class="filter_wrap">
        <div class="left_filter" v-if="left_filter == true">
          <div class="header_section top">
            <div>
              <span class="main_title">
                Filter
                <span class="mdi mdi-filter-menu"></span>
              </span>
            </div>
            <div>
              <span class="option">Reset</span>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Severity</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                </div>
                <div class="check_label">
                  <span>Severity 1</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-2" name="checkbox-2"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Severity 2</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Type</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Super admin</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Office admin</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Bio security</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Status</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Block</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Work from home</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Office</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <multiselect
                v-model="multiselect"
                :options="[
                  'Alphabet',
                  'Nestle',
                  'Tencent',
                  'Facebook',
                  'Alibaba'
                ]"
                :multiple="true"
              ></multiselect>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Compliance</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Not Onboarded</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Not Shared</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="employees_table">
          <thead>
            <tr>
              <th style="width:25%">Citizen Id</th>
              <th style="width:25%;text-align:center">Email Id</th>
              <th style="width:25%;text-align:center">Phone</th>
              <th style="width:25%;text-align:center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/3.jpg" alt />
                  <span id="Loki Redmond" @click="view_profile">Loki Redmond</span>
                </div>
              </td>
              <td>lokiredmonf@gmail.com</td>
              <td>+1-202-555-0135</td>
              <td class="status_3">
                <span>Work from home</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/1.jpg" alt />
                  <span id="Ajay Herman" @click="view_profile">Ajay Herman</span>
                </div>
              </td>
              <td>ajay@gmail.com</td>
              <td>+1-202-555-0189</td>
              <td class="status_3">
                <span>Work from home</span>
              </td>
            </tr>
            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/2.jpg" alt />
                  <span id="Saira Mays" @click="view_profile">Saira Mays</span>
                </div>
              </td>
              <td>sairamays@gmail.com</td>
              <td>+1-202-555-0197</td>
              <td class="status_2">
                <span>Block</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/6.jpg" alt />
                  <span id="Kaycee Warren" @click="view_profile">Kaycee Warren</span>
                </div>
              </td>
              <td>kaycee@gmail.com</td>
              <td>+1-202-555-0180</td>
              <td class="status_3">
                <span>Work from home</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/2.jpg" alt />
                  <span id="Jules Case" @click="view_profile">Jules Case</span>
                </div>
              </td>
              <td>jules@gmail.com</td>
              <td>+1-202-555-0197</td>
              <td class="status_2">
                <span>Block</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/4.jpg" alt />
                  <span id="Gurdeep Stevens" @click="view_profile">Gurdeep Stevens</span>
                </div>
              </td>
              <td>gurdeepw@gmail.com</td>
              <td>+1-202-555-0135</td>
              <td class="status_3">
                <span>Work from home</span>
              </td>
            </tr>
            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/1.jpg" alt />
                  <span id="Kaleb Read" @click="view_profile">Kaleb Read</span>
                </div>
              </td>
              <td>kalebread@gmail.com</td>
              <td>+1-202-555-0189</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="user">
                  <img src="../../../assets/users/7.jpg" alt />
                  <span id="Cleo Mccormick" @click="view_profile">Cleo Mccormick</span>
                </div>
              </td>
              <td>cleaomaccormick@gmail.com</td>
              <td>+1-202-555-0135</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Add employee -->
    <modal name="add_citizen" transition="pop-out" :width="600" height="auto">
      <addCitizen></addCitizen>
    </modal>
  </div>
</template>

<script>
import addCitizen from "./add_citizen/add_citizens.vue";

export default {
  name: "Citizens_G",
  components: {
    addCitizen
  },
  data() {
    return {
      left_filter: false,
      multiselect: null
    };
  },
  methods: {
    view_profile: function(e) {
      var id = e.currentTarget.id;
      this.$router.push("/xv-admin-g/citizens:" + id);
    },
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    add_citizen: function() {
      this.$modal.show("add_citizen");
    }
  }
};
</script>
